import React from 'react';
import './Banner.css';

function Banner() {
	return (
		<svg
			width="40vw"
			height="60vh"
			viewBox="0 0 886 655"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className="banner"
		>
			<g id="undraw_svg" clipPath="url(#clip0)">
				<path
					id="soil"
					d="M854.404 400.738C854.404 404.748 845.411 407.725 844.527 411.594C843.65 415.431 848.993 421.265 847.302 424.93C845.555 428.677 843.49 432.267 841.131 435.662C838.916 438.834 832.074 438.371 829.269 441.345C826.522 444.046 823.612 446.576 820.556 448.921C817.579 451.397 813.546 451.916 810.161 454.195C806.943 456.362 807.332 464.311 803.772 466.284C800.37 468.17 795.162 466.653 791.471 468.348C787.929 469.975 786.061 475.859 782.274 477.298C778.622 478.685 774.102 478.088 770.24 479.29C766.503 480.453 762.322 480.264 758.406 481.244C754.604 482.195 751.7 487.895 747.744 488.663C743.89 489.412 739.374 487.415 735.388 487.982C731.497 488.536 726.971 483.61 722.967 483.983C719.049 484.348 715.357 486.628 711.344 486.812C707.409 486.993 703.519 488.726 699.505 488.726C695.491 488.726 691.35 492.491 687.416 492.311C683.403 492.126 679.77 486.419 675.852 486.055C671.848 485.682 667.072 491.643 663.18 491.089C659.195 490.522 656.039 484.687 652.185 483.938C648.228 483.17 643.118 487.34 639.315 486.389C635.398 485.409 633.074 478.621 629.336 477.457C625.475 476.256 620.689 477.884 617.037 476.496C613.25 475.057 608.636 475.288 605.093 473.661C601.403 471.966 598.753 467.955 595.351 466.069C591.791 464.096 590.149 459.202 586.931 457.035C583.545 454.755 578.388 455.046 575.411 452.57C572.268 449.956 566.379 449.82 563.727 447.008C560.921 444.033 559.786 439.039 557.572 435.867C555.239 432.527 559.817 425.465 558.188 421.934C556.499 418.27 549.433 416.782 548.556 412.945C547.652 408.939 547.188 404.845 547.172 400.738C547.172 396.728 553.215 393.663 554.099 389.795C554.976 385.958 550.528 380.447 552.219 376.783C553.848 373.252 553.64 367.824 555.973 364.483C558.188 361.312 563.716 360.068 566.521 357.094C569.173 354.282 573.921 353.498 577.064 350.884C580.04 348.409 579.661 340.943 583.046 338.664C586.265 336.497 590.759 335.508 594.319 333.535C597.721 331.649 602.536 331.967 606.226 330.272C609.768 328.645 615.317 331.851 619.104 330.412C622.756 329.024 625.718 325.991 629.579 324.789C633.316 323.626 635.072 314.754 638.988 313.775C642.79 312.824 647.469 314.403 651.425 313.634C655.279 312.885 660.465 319.885 664.45 319.318C668.341 318.764 671.252 309.42 675.255 309.047C679.174 308.682 683.592 313.522 687.605 313.338C691.54 313.157 695.491 315.993 699.505 315.993C703.518 315.993 707.517 312.101 711.451 312.281C715.464 312.466 719.002 317.609 722.92 317.973C726.924 318.346 731.839 310.524 735.731 311.077C739.716 311.645 742.795 317.692 746.649 318.44C750.606 319.209 755.561 315.455 759.365 316.406C763.281 317.385 765.637 323.813 769.375 324.976C773.236 326.178 775.615 330.712 779.267 332.1C783.054 333.539 790.09 326.806 793.633 328.433C797.323 330.128 800.511 333.061 803.913 334.947C807.473 336.92 813.133 335.928 816.352 338.095C819.737 340.374 820.569 346.493 823.546 348.969C826.689 351.583 831.874 352.37 834.526 355.182C837.331 358.156 837.721 363.486 839.936 366.658C842.268 369.998 842.196 374.626 843.824 378.157C845.514 381.821 850.026 384.592 850.902 388.428C851.786 392.296 854.404 396.729 854.404 400.738Z"
					fill="#3F3D56"
				/>
				<g id="hands">
					<path
						id="Vector"
						d="M377.697 443.685C377.697 443.685 495.36 429.565 536.542 407.209C577.724 384.854 883.647 374.264 883.647 443.685C883.647 513.106 531.835 543.698 531.835 543.698L347.105 533.109L377.697 443.685Z"
						fill="#FBBEBE"
					/>
					<path
						id="Vector_2"
						d="M411.819 430.742L387.11 502.516L0 507.223V401.326C0 401.326 148.255 367.204 265.918 440.155C265.918 440.155 404.76 423.682 411.819 430.742Z"
						fill="#6C63FF"
					/>
					<path
						id="Vector_3"
						d="M430.645 474.277C430.645 474.277 563.604 406.033 649.498 431.919C735.392 457.804 855.408 413.093 869.527 428.389C883.647 443.685 903.649 608.413 734.215 617.826C564.781 627.239 420.056 589.587 420.056 589.587L430.645 474.277Z"
						fill="#FBBEBE"
					/>
					<path
						id="Vector_4"
						d="M399.334 467.009C399.334 467.009 451.825 463.688 449.471 482.514C447.118 501.34 444.765 647.241 430.645 650.771C416.526 654.301 304.746 654.301 258.858 654.301H0V428.727C0 428.727 183.554 417.799 275.331 463.688C275.331 463.688 385.672 462.095 399.334 467.009Z"
						fill="#6C63FF"
					/>
				</g>
				<g id="right_tree">
					<path
						id="Vector_5"
						d="M805.989 104.413C821.585 104.413 834.228 98.2721 834.228 90.6969C834.228 83.1217 821.585 76.9807 805.989 76.9807C790.393 76.9807 777.75 83.1217 777.75 90.6969C777.75 98.2721 790.393 104.413 805.989 104.413Z"
						fill="#57B894"
					/>
					<path
						id="Vector_6"
						d="M847.051 48.0406C842.911 45.1942 838.061 43.5571 833.043 43.3129C828.026 43.0687 823.039 44.2271 818.643 46.6581C805.409 54.2304 801.212 71.9104 803.831 86.9305C806.45 101.951 814.298 115.453 819.969 129.606C827.587 148.615 831.325 169.71 827.003 189.727C822.681 209.745 809.415 228.415 790.397 236.012C772.745 243.064 752.882 240.084 734.126 236.999"
						stroke="#3F3D56"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_7"
						d="M781.28 265.611C796.876 265.611 809.519 259.47 809.519 251.895C809.519 244.32 796.876 238.179 781.28 238.179C765.684 238.179 753.041 244.32 753.041 251.895C753.041 259.47 765.684 265.611 781.28 265.611Z"
						fill="#57B894"
					/>
					<path
						id="Vector_8"
						d="M854.231 140.888C869.827 140.888 882.47 134.747 882.47 127.172C882.47 119.597 869.827 113.456 854.231 113.456C838.635 113.456 825.992 119.597 825.992 127.172C825.992 134.747 838.635 140.888 854.231 140.888Z"
						stroke="#3F3D56"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_9"
						d="M802.459 102.06C818.055 102.06 830.699 95.9188 830.699 88.3436C830.699 80.7684 818.055 74.6275 802.459 74.6275C786.863 74.6275 774.22 80.7684 774.22 88.3436C774.22 95.9188 786.863 102.06 802.459 102.06Z"
						stroke="#3F3D56"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_10"
						d="M777.75 263.258C793.346 263.258 805.989 257.117 805.989 249.541C805.989 241.966 793.346 235.825 777.75 235.825C762.154 235.825 749.511 241.966 749.511 249.541C749.511 257.117 762.154 263.258 777.75 263.258Z"
						stroke="#3F3D56"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_11"
						d="M857.761 143.242C873.357 143.242 886 137.101 886 129.526C886 121.95 873.357 115.809 857.761 115.809C842.165 115.809 829.522 121.95 829.522 129.526C829.522 137.101 842.165 143.242 857.761 143.242Z"
						fill="#57B894"
					/>
					<path
						id="Vector_12"
						d="M856.584 63.231C872.18 63.231 884.823 57.0901 884.823 49.5149C884.823 41.9397 872.18 35.7988 856.584 35.7988C840.988 35.7988 828.345 41.9397 828.345 49.5149C828.345 57.0901 840.988 63.231 856.584 63.231Z"
						fill="#57B894"
					/>
					<path
						id="Vector_13"
						d="M853.054 60.8778C868.65 60.8778 881.294 54.7369 881.294 47.1617C881.294 39.5865 868.65 33.4456 853.054 33.4456C837.458 33.4456 824.815 39.5865 824.815 47.1617C824.815 54.7369 837.458 60.8778 853.054 60.8778Z"
						stroke="#3F3D56"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_14"
						d="M822.462 175.011C838.058 175.011 850.701 168.87 850.701 161.294C850.701 153.719 838.058 147.578 822.462 147.578C806.866 147.578 794.223 153.719 794.223 161.294C794.223 168.87 806.866 175.011 822.462 175.011Z"
						fill="#57B894"
					/>
					<path
						id="Vector_15"
						d="M818.932 172.657C834.528 172.657 847.171 166.516 847.171 158.941C847.171 151.366 834.528 145.225 818.932 145.225C803.336 145.225 790.693 151.366 790.693 158.941C790.693 166.516 803.336 172.657 818.932 172.657Z"
						stroke="#3F3D56"
						strokeMiterlimit="10"
					/>
				</g>
				<g id="centre_tree">
					<path
						id="Vector_16"
						d="M675.384 74.9973C690.98 74.9973 703.623 68.8564 703.623 61.2812C703.623 53.706 690.98 47.5651 675.384 47.5651C659.788 47.5651 647.145 53.706 647.145 61.2812C647.145 68.8564 659.788 74.9973 675.384 74.9973Z"
						fill="#57B894"
					/>
					<path
						id="Vector_17"
						d="M701.27 125.592C716.866 125.592 729.509 119.451 729.509 111.876C729.509 104.301 716.866 98.16 701.27 98.16C685.674 98.16 673.031 104.301 673.031 111.876C673.031 119.451 685.674 125.592 701.27 125.592Z"
						stroke="#3F3D56"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_18"
						d="M771.867 213.839C787.463 213.839 800.106 207.698 800.106 200.123C800.106 192.548 787.463 186.407 771.867 186.407C756.271 186.407 743.628 192.548 743.628 200.123C743.628 207.698 756.271 213.839 771.867 213.839Z"
						fill="#57B894"
					/>
					<path
						id="Vector_19"
						d="M768.337 211.486C783.933 211.486 796.576 205.345 796.576 197.77C796.576 190.195 783.933 184.054 768.337 184.054C752.741 184.054 740.098 190.195 740.098 197.77C740.098 205.345 752.741 211.486 768.337 211.486Z"
						stroke="#3F3D56"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_20"
						d="M692.304 28.2855C687.289 28.5688 682.451 30.2436 678.334 33.1223C674.217 36.0009 670.984 39.9694 668.996 44.5829C663.167 58.6716 670.672 75.2209 681.937 85.4946C693.203 95.7682 707.674 101.641 720.823 109.359C738.483 119.727 754.353 134.119 763.19 152.593C772.026 171.067 772.966 193.952 762.579 211.601C752.938 227.982 735.408 237.787 718.688 246.829"
						stroke="#3F3D56"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_21"
						d="M771.867 133.829C787.463 133.829 800.106 127.688 800.106 120.113C800.106 112.537 787.463 106.396 771.867 106.396C756.271 106.396 743.628 112.537 743.628 120.113C743.628 127.688 756.271 133.829 771.867 133.829Z"
						stroke="#3F3D56"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_22"
						d="M775.397 136.182C790.993 136.182 803.636 130.041 803.636 122.466C803.636 114.891 790.993 108.75 775.397 108.75C759.801 108.75 747.158 114.891 747.158 122.466C747.158 130.041 759.801 136.182 775.397 136.182Z"
						fill="#57B894"
					/>
					<path
						id="Vector_23"
						d="M733.039 96.1766C748.635 96.1766 761.278 90.0357 761.278 82.4605C761.278 74.8853 748.635 68.7444 733.039 68.7444C717.443 68.7444 704.799 74.8853 704.799 82.4605C704.799 90.0357 717.443 96.1766 733.039 96.1766Z"
						stroke="#3F3D56"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_24"
						d="M736.568 98.5298C752.164 98.5298 764.807 92.3889 764.807 84.8137C764.807 77.2385 752.164 71.0976 736.568 71.0976C720.972 71.0976 708.329 77.2385 708.329 84.8137C708.329 92.3889 720.972 98.5298 736.568 98.5298Z"
						fill="#57B894"
					/>
					<path
						id="Vector_25"
						d="M704.799 127.945C720.395 127.945 733.039 121.805 733.039 114.229C733.039 106.654 720.395 100.513 704.799 100.513C689.204 100.513 676.56 106.654 676.56 114.229C676.56 121.805 689.204 127.945 704.799 127.945Z"
						fill="#57B894"
					/>
					<path
						id="Vector_26"
						d="M754.218 179.717C769.814 179.717 782.457 173.576 782.457 166.001C782.457 158.426 769.814 152.285 754.218 152.285C738.622 152.285 725.979 158.426 725.979 166.001C725.979 173.576 738.622 179.717 754.218 179.717Z"
						fill="#57B894"
					/>
					<path
						id="Vector_27"
						d="M671.854 72.644C687.45 72.644 700.093 66.5031 700.093 58.9279C700.093 51.3527 687.45 45.2118 671.854 45.2118C656.258 45.2118 643.615 51.3527 643.615 58.9279C643.615 66.5031 656.258 72.644 671.854 72.644Z"
						stroke="#3F3D56"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_28"
						d="M750.688 177.364C766.284 177.364 778.927 171.223 778.927 163.648C778.927 156.073 766.284 149.932 750.688 149.932C735.092 149.932 722.449 156.073 722.449 163.648C722.449 171.223 735.092 177.364 750.688 177.364Z"
						stroke="#3F3D56"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_29"
						d="M758.924 62.0544C774.52 62.0544 787.163 55.9135 787.163 48.3383C787.163 40.7631 774.52 34.6222 758.924 34.6222C743.328 34.6222 730.685 40.7631 730.685 48.3383C730.685 55.9135 743.328 62.0544 758.924 62.0544Z"
						fill="#57B894"
					/>
					<path
						id="Vector_30"
						d="M755.394 59.7011C770.99 59.7011 783.633 53.5602 783.633 45.985C783.633 38.4098 770.99 32.2689 755.394 32.2689C739.798 32.2689 727.155 38.4098 727.155 45.985C727.155 53.5602 739.798 59.7011 755.394 59.7011Z"
						stroke="#3F3D56"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_31"
						d="M693.033 30.2855C708.629 30.2855 721.272 24.1446 721.272 16.5694C721.272 8.99415 708.629 2.85324 693.033 2.85324C677.437 2.85324 664.794 8.99415 664.794 16.5694C664.794 24.1446 677.437 30.2855 693.033 30.2855Z"
						fill="#57B894"
					/>
					<path
						id="Vector_32"
						d="M689.503 27.9322C705.099 27.9322 717.742 21.7913 717.742 14.2161C717.742 6.64091 705.099 0.5 689.503 0.5C673.907 0.5 661.264 6.64091 661.264 14.2161C661.264 21.7913 673.907 27.9322 689.503 27.9322Z"
						stroke="#3F3D56"
						strokeMiterlimit="10"
					/>
				</g>
				<g id="left_tree">
					<path
						id="Vector_33"
						d="M634.202 132.652C649.798 132.652 662.441 126.511 662.441 118.936C662.441 111.361 649.798 105.22 634.202 105.22C618.606 105.22 605.963 111.361 605.963 118.936C605.963 126.511 618.606 132.652 634.202 132.652Z"
						stroke="#3F3D56"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_34"
						d="M710.683 225.606C726.279 225.606 738.922 219.465 738.922 211.889C738.922 204.314 726.279 198.173 710.683 198.173C695.087 198.173 682.444 204.314 682.444 211.889C682.444 219.465 695.087 225.606 710.683 225.606Z"
						fill="#57B894"
					/>
					<path
						id="Vector_35"
						d="M707.153 223.252C722.749 223.252 735.392 217.111 735.392 209.536C735.392 201.961 722.749 195.82 707.153 195.82C691.557 195.82 678.914 201.961 678.914 209.536C678.914 217.111 691.557 223.252 707.153 223.252Z"
						stroke="#3F3D56"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_36"
						d="M645.239 114.179C640.224 114.463 635.386 116.137 631.269 119.016C627.152 121.895 623.918 125.863 621.93 130.477C616.102 144.565 623.607 161.115 634.872 171.388C646.138 181.662 660.609 187.534 673.758 195.253C691.418 205.621 707.288 220.013 716.124 238.487C724.961 256.961 725.901 279.845 715.514 297.495C705.873 313.876 688.343 323.68 671.623 332.722"
						stroke="#3F3D56"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_37"
						d="M596.55 171.481C612.146 171.481 624.789 165.34 624.789 157.765C624.789 150.189 612.146 144.048 596.55 144.048C580.954 144.048 568.311 150.189 568.311 157.765C568.311 165.34 580.954 171.481 596.55 171.481Z"
						fill="#57B894"
					/>
					<path
						id="Vector_38"
						d="M593.02 169.127C608.616 169.127 621.259 162.987 621.259 155.411C621.259 147.836 608.616 141.695 593.02 141.695C577.424 141.695 564.781 147.836 564.781 155.411C564.781 162.987 577.424 169.127 593.02 169.127Z"
						stroke="#3F3D56"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_39"
						d="M694.21 164.421C709.806 164.421 722.449 158.28 722.449 150.705C722.449 143.13 709.806 136.989 694.21 136.989C678.614 136.989 665.971 143.13 665.971 150.705C665.971 158.28 678.614 164.421 694.21 164.421Z"
						fill="#57B894"
					/>
					<path
						id="Vector_40"
						d="M690.68 162.068C706.276 162.068 718.919 155.927 718.919 148.352C718.919 140.776 706.276 134.635 690.68 134.635C675.084 134.635 662.441 140.776 662.441 148.352C662.441 155.927 675.084 162.068 690.68 162.068Z"
						stroke="#3F3D56"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_41"
						d="M637.732 135.005C653.328 135.005 665.971 128.864 665.971 121.289C665.971 113.714 653.328 107.573 637.732 107.573C622.136 107.573 609.493 113.714 609.493 121.289C609.493 128.864 622.136 135.005 637.732 135.005Z"
						fill="#57B894"
					/>
					<path
						id="Vector_42"
						d="M654.205 187.953C669.801 187.953 682.444 181.813 682.444 174.237C682.444 166.662 669.801 160.521 654.205 160.521C638.609 160.521 625.965 166.662 625.965 174.237C625.965 181.813 638.609 187.953 654.205 187.953Z"
						fill="#57B894"
					/>
					<path
						id="Vector_43"
						d="M650.675 185.6C666.271 185.6 678.914 179.459 678.914 171.884C678.914 164.309 666.271 158.168 650.675 158.168C635.079 158.168 622.436 164.309 622.436 171.884C622.436 179.459 635.079 185.6 650.675 185.6Z"
						stroke="#3F3D56"
						strokeMiterlimit="10"
					/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0">
					<rect width="886" height="654.301" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default Banner;
